import React from "react";
import Dashboard121Insights from "@components/dashboard/Dashboard121Insights";

// O Dashboard121Insights é o componente v45 verbatim. Ele gerencia
// internamente toda a navegação entre abas, filtros e estado local.
// A migração futura para Redux/services está planejada — por enquanto
// o componente é auto-contido e renderiza fullscreen.
export default function DashboardPage() {
  return <Dashboard121Insights />;
}
